import { useContext } from "react";
import { AuthContext } from "@adapters/AuthContextProvider";
import { MenuItem } from "@components/layout/Menu";
import { Tab } from "@components/menu/Tab";
import { ImgSrc } from "@config/image";

type SupportMenuProps = {
  onClick: () => void;
};

const SupportMenu = ({ onClick }: SupportMenuProps) => {
  const { userInfo } = useContext(AuthContext);

  const userChatSupportMenu: MenuItem = {
    title: "Contact Support",
    type: "link",
    onClick,
    items: [],
    level: 2,
    selected: false,
  };

  const userForumSupportMenu: MenuItem = {
    title: "Visit our Forum",
    type: "link",
    href: "https://discuss.blues.com",
    items: [],
    level: 2,
    selected: false,
  };

  const menuItem: MenuItem = {
    title: "Help",
    icon: ImgSrc("/images/icons/support_white.svg"),
    type: "section",
    level: 1,
    selected: false,
    items: [
      {
        title: "Notehub Status",
        type: "link",
        href: "https://status.notehub.io",
        items: [],
        level: 2,
        selected: false,
      },
    ],
  };

  // Conditionally add chat support or forum support
  if (userInfo.phoneSupport || userInfo.chatSupport) {
    menuItem.items.push(userChatSupportMenu);
  } else {
    menuItem.items.push(userForumSupportMenu);
  }

  return (
    <>
      <div className="supportMenuContainer">
        <Tab {...menuItem} />
      </div>
      <style jsx>{`
        .supportMenuContainer {
          padding-right: 0.5rem;
        }
      `}</style>
    </>
  );
};

export default SupportMenu;
